import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class BookingDeclinedGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired
		}).isRequired
	};

	render() {
		const { content: { guestName, checkIn, logo, siteName, listCity, listTitle, checkOut } } = this.props;
		let checkInDate, checkOutDate
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '';
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<EmptySpace height={20} />
					<div style={fontWeightBold}>
						Bonjour {guestName},
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}>
						Merci d'avoir considéré {siteName} pour votre voyage à {listCity}. Malheureusement, votre demande de réservation pour {listTitle} du {checkInDate} au {checkOutDate} a été refusée par l'hôte.
					</div>
					<div>
						Nous vous remercions de votre intérêt et espérons que vous trouverez un autre hébergement qui vous conviendra !
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingDeclinedGuest;
